// extracted by mini-css-extract-plugin
module.exports = {"modal":"CardDetailsModal_modal__2HHph","modal_background":"CardDetailsModal_modal_background__R0Esg","modal-content":"CardDetailsModal_modal-content__lCYoq"};